import { Button, ButtonProps } from '@mui/material'
import { AppBlack, AppBorderGrey, AppGreen } from 'appconstants/AppColors'

interface AddButtonProps extends ButtonProps {
  buttonText?: string
  startIcon?: any
}

function AddButton(props: AddButtonProps) {
  const { buttonText, startIcon, ...buttonProps } = props
  return (
    <Button
      variant='outlined'
      startIcon={startIcon}
      {...buttonProps}
      sx={{
        '& .MuiButton-startIcon': {
          marginLeft: '-10px',
          marginRight: '6px',
        },
        fontWeight: 600,
        fontSize: '1rem',
        color: AppGreen,
        border: 1,
        borderColor: AppGreen,
        borderRadius: '50px',
        pt: 1,
        pb: 1,
        pl: 3,
        pr: 3,
        textTransform: 'none',

        ...buttonProps.sx,
      }}
    >
      {buttonText}
    </Button>
  )
}
export default AddButton
